import React from "react";
import compose from "recompose/compose";
import mapProps from "recompose/mapProps";
import { injectIntl, defineMessages } from "react-intl";
import Select from "../Select";

const titles = [
  {
    label: "",
    value: "",
  },
  {
    label: "Mr",
    value: "Mr",
  },
  {
    label: "Ms",
    value: "Ms",
  },
];

const messages = defineMessages({
  Mr: {
    id: "components.atoms.Form.Input.TitleSelect.mr",
    defaultMessage: "Mr",
  },
  Ms: {
    id: "components.atoms.Form.Input.TitleSelect.ms",
    defaultMessage: "Ms",
  },
});

const TitleSelect = (props) => {
  return <Select {...props} options={props.options} />;
};

export default compose(
  injectIntl,
  mapProps(({ placeholder, ...props }) => ({
    ...props,
    options: titles.map((option) => ({
      label: option.label
        ? props.intl.formatMessage(messages[option.label])
        : placeholder,
      value: option.value,
    })),
  }))
)(TitleSelect);
